<template>

<div id="modal">
  <transition name="modal">
    <div class="modal-mask" @click="this.hideModal">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
            
            <div id="alert-dialog">
              <div class="alert-icon"></div>
              <div class="alert-message">
                <h1>Ooops!</h1>
                <p>You need to "Pledge to run" to access the resources and get running reminders.</p>
              </div>
            </div>

            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <div class="close-button" @click="this.hideModal">
                Close
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</div>

</template>

<script>

import Vue from 'vue'

export default {
  name : 'modal',
  //  store,
  data() {
    return {
      sharedState : this.$store.state
    }
  },

  filters: {
  },

  // computed property for form validation state
  computed: {
  },
  // methods
  methods: {

    hideModal: function() {
      // Show the sharing page
      //console.log("Pledge complete!");
      
      // Mark the pledge as Completed
      this.sharedState.showModal = false;
    }
    
  },
  mounted: function () {

    var p = this;

    document.addEventListener("keydown", (e) => {
      if (p.sharedState.showModal && e.keyCode == 27) {
        p.sharedState.showModal = false;
      }
    });
  }
}



</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 0px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow: hidden;
}

@media only screen and (max-width: 500px) {
  /* Small screen styles */

  .modal-container {
    width: 100%;
  }

}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 10px;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-footer .close-button{
  border-top: 1px solid #ddd;
  line-height: 46px;
  text-align: center;
  background-color: rgb(237, 237, 237);
  text-transform: uppercase;
  color: #999;
  letter-spacing: 1px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.modal-footer .close-button:hover{
  background-color: rgb(207, 207, 207);
  color: #666;
}

#alert-dialog{

}

#alert-dialog .alert-icon{
  background: url(/static/img/ry-icons.b890878.png) -700px center no-repeat;
  width: 100px;
  height: 100px;
  position: absolute;
}

#alert-dialog .alert-message{
  margin-left: 120px;
  font-size: 18px;
  font-weight: normal;
}

#alert-dialog h1{
  margin: 0;
  font-weight: 100;
  font-size: 30px;
  font-family: "Avenir", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

#alert-dialog p{
  margin-top: 5px;
  line-height: 28px;
  color: #666;
}

</style>



// WEBPACK FOOTER //
// Modal.vue?a9f62330